<!--  -->

<template>
  <div class="carriage">
    <div class="toptext">
      <div class="img"></div>
      <span>五城各平台承运分布</span>
    </div>
    <div class="carri" v-if="rightChart1.currentData.length !== 0">
      <div class="carri1">
        <span class="name">{{ rightChart1.currentData[0].a }}</span>
        <div class="carri1text">
          <div class="text1">{{ rightChart1.currentData[0].b / 1000 }}</div>
          <span class="text2">吨</span>
        </div>
      </div>
      <div class="carri2">
        <span class="name">{{ rightChart1.currentData[1].a }}</span>
        <div class="carri2text">
          <div class="text1">{{ rightChart1.currentData[1].b / 1000 }}</div>
          <span class="text2">吨</span>
        </div>
      </div>
      <div class="carri3">
        <span class="name">{{ rightChart1.currentData[2].a }}</span>
        <div class="carri3text">
          <div class="text1">{{ rightChart1.currentData[2].b / 1000 }}</div>
          <span class="text2">吨</span>
        </div>
      </div>
      <div class="carri4">
        <span class="name">{{ rightChart1.currentData[3].a }}</span>
        <div class="carri4text">
          <div class="text1">{{ rightChart1.currentData[3].b / 1000 }}</div>
          <!-- <div class="text1">0</div> -->
          <span class="text2">吨</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    rightChart1: {
      type: Object,
      default: function () {
        return {
          currentData: []
        };
      }
    }
  },

  data () {
    return {};
  },
  computed: {},
  watch: {
    rightChart1: {
      handler (data) { },
      deep: true
    }
  },

  mounted () { },
  methods: {
    // 初始化
  }
};
</script>

<style scoped>
.carriage {
  width: 100%;
  height: 30%;
  margin: 1% auto;
  background-image: url('../assets/img/CapacityPolyline/右3-bg.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 100% 103%;
}
.carriage .toptext {
  width: 100%;
  height: 15%;
  display: flex;
  background-image: url('../assets/img/rightbg/右1line.png');
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: 90% 50%;
  position: relative;
}
.carriage .toptext .img {
  position: absolute;
  top: 10%;
  left: 2.5%;
  width: 40px;
  height: 40px;
  background-image: url('../assets/img/rightbg/shuliang.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 110%;
}
.carriage .toptext span {
  margin-left: 11%;
  margin-top: 3%;
  color: aliceblue;
  font-family: 'PingFangSC-Regular';
  font-size: 18px;
}
.carriage .carri {
  clear: both;
  width: 100%;
  height: 85%;
}
.carriage .carri .carri1,
.carri2,
.carri3,
.carri4 {
  float: left;
  width: 50%;
  height: 50%;
}
.carriage .carri .carri1 {
  background-image: url('../assets/img/rightbg/1.png');
  background-repeat: no-repeat;
  background-position: 60% 50%;
  position: relative;
}
.carriage .carri .carri1 .name {
  color: aliceblue;
  font-size: 16px;
  position: absolute;
  right: 19%;
  top: 15%;
}
.carriage .carri .carri2 .name {
  color: aliceblue;
  font-size: 16px;
  position: absolute;
  right: 24%;
  top: 14%;
}
.carriage .carri .carri3 .name {
  color: aliceblue;
  font-size: 16px;
  position: absolute;
  right: 12%;
  top: 10%;
}
.carriage .carri .carri4 .name {
  color: aliceblue;
  font-size: 16px;
  position: absolute;
  right: 25%;
  top: 10%;
}
.carriage .carri .carri1 .carri1text {
  display: flex;
  width: 40%;
  height: 21%;
  position: absolute;
  top: 50%;
  left: 45%;
  color: aliceblue;
  font-family: 'DIN Alternate';
}
.carriage .carri .carri2 .carri2text {
  display: flex;
  width: 40%;
  height: 21%;
  position: absolute;
  top: 50%;
  left: 40%;
  color: aliceblue;
  font-family: 'DIN Alternate';
}
.carriage .carri .carri3 .carri3text {
  display: flex;
  width: 40%;
  height: 21%;
  position: absolute;
  top: 45%;
  left: 50%;
  color: aliceblue;
  font-family: 'DIN Alternate';
}
.carriage .carri .carri4 .carri4text {
  display: flex;
  width: 40%;
  height: 21%;
  position: absolute;
  top: 45%;
  left: 40%;
  color: aliceblue;
  font-family: 'DIN Alternate';
}
.carriage .carri .carri1 .carri1text .text1,
.carriage .carri .carri2 .carri2text .text1,
.carriage .carri .carri3 .carri3text .text1,
.carriage .carri .carri4 .carri4text .text1 {
  font-size: 20px;
}
.carriage .carri .carri1 .carri1text .text2,
.carriage .carri .carri2 .carri2text .text2,
.carriage .carri .carri3 .carri3text .text2,
.carriage .carri .carri4 .carri4text .text2 {
  padding-left: 5%;
  padding-top: 5%;
  font-size: 14px;
  color: rgb(143, 143, 143);
}
.carriage .carri .carri2 {
  background-image: url('../assets/img/rightbg/2.png');
  background-repeat: no-repeat;
  background-position: 30% 50%;
  position: relative;
}
.carriage .carri .carri3 {
  background-image: url('../assets/img/rightbg/3.png');
  background-repeat: no-repeat;
  background-position: 60% 40%;
  position: relative;
}
.carriage .carri .carri4 {
  background-image: url('../assets/img/rightbg/4.png');
  background-repeat: no-repeat;
  background-position: 30% 40%;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/carriage.vue